import axios from 'axios';
import { HOST_URL } from 'config';
import { GetDefaultHeaders } from 'common/Js/AjaxHelper/Helpers';

const axiosInstance = axios.create({
  baseURL: HOST_URL
});

axiosInstance.interceptors.request.use(
  config => {
    if (config.headers === undefined) {
      config.headers = {};
    }

    config.headers = { ...GetDefaultHeaders(), ...config.headers };

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(
      (error.response && error.response.data) ||
        (error.response && error.response.status === 401 && 'You are not authorized to perform this operation') ||
        'Something went wrong'
    );
  }
);

export default axiosInstance;
